import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { UpsellSurface } from 'fym-shared/src/music24/watermarkUpsell';
import { openSMLUpgradePrompt } from '../../../redux/slices/appInfo/slice';
import { SMLUpgradeFeature } from '../config/music24PlanCapabilities';
import { useUpsellEventFacts } from './useUpsellEventFacts';
import { trackUpsellClicked } from './watermarkUpsellAnalytics';

/**
 * Opens the offer (design: trial-upsell b4) from a surface: each "Remove the watermark" button
 * calls it. It sends `upsell_clicked` and keeps the surface for the checkout. A member gets the
 * owner note and the native web view gets the note of the app: the offer itself decides.
 */
export function useOpenWatermarkOffer(): (surface: UpsellSurface) => void {
  const dispatch = useDispatch();
  const eventFacts = useUpsellEventFacts();
  return useCallback(
    (surface: UpsellSurface) => {
      trackUpsellClicked(eventFacts(surface));
      dispatch(openSMLUpgradePrompt({ feature: SMLUpgradeFeature.watermark, upsellSurface: surface }));
    },
    [dispatch, eventFacts]
  );
}
